import actions from './actions';
import initialState from '../initialState';

export const brokerClientReducer = (state = initialState.brokerClientState, action) => {
    switch (action.type) {
        case actions.OPEN_BROKER_CLIENT_STATE:
            return {
                ...state,
                openBrokerClientModal: action.state.openBrokerClientModal,
            };
        case actions.BROKER_CLIENT_ID_STATE:
            return { ...state, brokerClientId: action.state.brokerClientId };
        case actions.BROKER_CLIENT_BROKER_ID_STATE:
            return { ...state, brokerId: action.state.brokerId };
        default:
            return state;
    }
};

export default brokerClientReducer;
